import { Icons } from '@commenda/kakashi';
import { IFormBuilderLinks } from '../../context/FormBuilderLinksContext';

interface HumanFormBuilderLinksProps {
  selectedFormId: string | undefined;
  /** The step's name, which a host opening the form in place uses to title it. */
  stepName: string;
  links: IFormBuilderLinks;
}

/** The step panel's way into the host's form builder: edit the selected form, or view it where the
 * host puts it. A real href on the edit link keeps open-in-new-tab working; the click itself goes
 * through the host's router. View is a button rather than a link because it opens in place, so
 * there is no address an open-in-new-tab could land on. Creating a form belongs to the forms list,
 * not here. */
export const HumanFormBuilderLinks = ({
  selectedFormId,
  stepName,
  links,
}: HumanFormBuilderLinksProps) => {
  // Nothing to edit or view until a form is chosen, and a bare row of dead actions reads as a bug.
  if (!selectedFormId) return null;

  const editHref = links.getEditHref(selectedFormId);

  return (
    <div className="flex items-center gap-md">
      <a
        href={editHref}
        onClick={(event) => {
          event.preventDefault();
          links.openHref(editHref);
        }}
        className="txt-small-medium flex items-center gap-xs text-text-brand-primary hover:underline"
      >
        <Icons.LinkExternal01 aria-hidden="true" className="size-4" />
        Edit form
      </a>
      {links.onViewForm !== undefined && (
        <button
          type="button"
          onClick={() => links.onViewForm?.(selectedFormId, stepName)}
          className="txt-small-medium flex items-center gap-xs text-text-brand-primary hover:underline"
        >
          <Icons.Eye aria-hidden="true" className="size-4" />
          View form
        </button>
      )}
    </div>
  );
};
